module.exports = __webpack_public_path__ + "media/src/images/cardrates/right_arrow-1b661b877f8f3e5539aaf35d04fcac6d.png";